import script from "./taxAtion.vue?vue&type=script&setup=true&lang=js"
export * from "./taxAtion.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__